var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.12913 14.2624C6.81247 14.2624 6.4958 14.1457 6.2458 13.8957L0.3625 8.01238C-0.120833 7.52905 -0.120833 6.72905 0.3625 6.24572L6.2458 0.362317C6.72913 -0.121016 7.52913 -0.121016 8.01247 0.362317C8.4958 0.84565 8.4958 1.64565 8.01247 2.12898L3.01247 7.12905L8.01247 12.1291C8.4958 12.6124 8.4958 13.4124 8.01247 13.8957C7.77913 14.1457 7.46247 14.2624 7.12913 14.2624Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.467a87778bf9855cb04aafb69371ed04.svg";
export { ForwardRef as ReactComponent };